<div class="container">
    <dynamo-form #passwordForm
                 formTitle="Passwort ändern"
                 submitButtonText="Passwort ändern"
                 [data]="passwordFormControls">
    </dynamo-form>
</div>
